import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="contact" className="py-24 bg-charcoal relative overflow-hidden" data-id="element-43">
      {/* Subtle brick accent */}
      <div className="absolute inset-0 brick-pattern opacity-10" data-id="element-44"></div>
      <div className="absolute inset-0 bg-charcoal/90" data-id="element-45"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-47">
          <span className="text-amber font-medium tracking-widest uppercase text-sm mb-2 block" data-id="element-48">
            Get in Touch
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-cream" data-id="element-49">
            Contact Us
          </h2>
          <div className="w-24 h-1 bg-warm-brown mx-auto mt-6" data-id="element-50"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16" data-id="element-51">
          {/* Contact Info Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-2 space-y-8" data-id="element-52">
            <p className="text-gray-400 text-lg leading-relaxed" data-id="element-53">
              Have a question, want to book a private event, or just want to say
              hello? We'd love to hear from you.
            </p>

            <div className="space-y-6 pt-2" data-id="element-54">
              <div className="flex items-start" data-id="element-55">
                <div className="w-10 h-10 bg-warm-brown/20 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-56">
                  <MapPin size={18} className="text-amber" data-id="element-57" />
                </div>
                <div data-id="element-58">
                  <h4 className="text-cream font-medium text-sm tracking-wider uppercase mb-1" data-id="element-59">
                    Address
                  </h4>
                  <p className="text-gray-400" data-id="element-60">
                    207 Broadway St.
                    <br data-id="element-61" />
                    Paducah, KY 42001
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-62">
                <div className="w-10 h-10 bg-warm-brown/20 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-63">
                  <Phone size={18} className="text-amber" data-id="element-64" />
                </div>
                <div data-id="element-65">
                  <h4 className="text-cream font-medium text-sm tracking-wider uppercase mb-1" data-id="element-66">
                    Phone
                  </h4>
                  <p className="text-gray-400" data-id="element-67">(270) 933-1707</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-68">
                <div className="w-10 h-10 bg-warm-brown/20 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-69">
                  <Mail size={18} className="text-amber" data-id="element-70" />
                </div>
                <div data-id="element-71">
                  <h4 className="text-cream font-medium text-sm tracking-wider uppercase mb-1" data-id="element-72">
                    Email
                  </h4>
                  <p className="text-gray-400" data-id="element-73">sun_cheah@yahoo.com</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-74">
                <div className="w-10 h-10 bg-warm-brown/20 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-75">
                  <Clock size={18} className="text-amber" data-id="element-76" />
                </div>
                <div data-id="element-77">
                  <h4 className="text-cream font-medium text-sm tracking-wider uppercase mb-1" data-id="element-78">
                    Hours
                  </h4>
                  <div className="text-gray-400 space-y-0.5 text-sm" data-id="element-79">
                    <p data-id="element-80">Mon – Thu: 4pm – 9pm</p>
                    <p data-id="element-81">Fri – Sat: 4pm – 10pm</p>
                    <p className="text-warm-brown font-medium" data-id="element-82">
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Form Column */}
          <div className="lg:col-span-3" data-id="element-83">
            {submitted ? <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="text-center py-16" data-id="element-84">
                <div className="w-16 h-16 rounded-full bg-amber/20 flex items-center justify-center mx-auto mb-6" data-id="element-85">
                  <Send size={28} className="text-amber" data-id="element-86" />
                </div>
                <h3 className="font-serif text-2xl text-cream mb-3" data-id="element-87">
                  Message Sent!
                </h3>
                <p className="text-gray-400" data-id="element-88">
                  Thank you for reaching out. We'll get back to you shortly.
                </p>
                <button onClick={() => {
              setSubmitted(false);
              setFormData({
                name: '',
                email: '',
                phone: '',
                message: ''
              });
            }} className="mt-8 text-amber hover:text-cream transition-colors text-sm tracking-wider uppercase" data-id="element-89">
                  Send Another Message
                </button>
              </motion.div> : <motion.form initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} onSubmit={handleSubmit} className="space-y-6" data-id="element-90">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-91">
                  <div data-id="element-92">
                    <label htmlFor="name" className="block text-cream text-sm font-medium tracking-wider uppercase mb-2" data-id="element-93">
                      Name
                    </label>
                    <input type="text" id="name" required value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className="w-full bg-white/5 border border-white/10 text-cream px-4 py-3 focus:outline-none focus:border-amber/60 focus:ring-1 focus:ring-amber/30 transition-colors placeholder-gray-500" placeholder="Your name" data-id="element-94" />
                  </div>
                  <div data-id="element-95">
                    <label htmlFor="email" className="block text-cream text-sm font-medium tracking-wider uppercase mb-2" data-id="element-96">
                      Email
                    </label>
                    <input type="email" id="email" required value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} className="w-full bg-white/5 border border-white/10 text-cream px-4 py-3 focus:outline-none focus:border-amber/60 focus:ring-1 focus:ring-amber/30 transition-colors placeholder-gray-500" placeholder="your@email.com" data-id="element-97" />
                  </div>
                </div>

                <div data-id="element-98">
                  <label htmlFor="phone" className="block text-cream text-sm font-medium tracking-wider uppercase mb-2" data-id="element-99">
                    Phone{' '}
                    <span className="text-gray-500 normal-case tracking-normal" data-id="element-100">
                      (optional)
                    </span>
                  </label>
                  <input type="tel" id="phone" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} className="w-full bg-white/5 border border-white/10 text-cream px-4 py-3 focus:outline-none focus:border-amber/60 focus:ring-1 focus:ring-amber/30 transition-colors placeholder-gray-500" placeholder="(270) 555-0000" data-id="element-101" />
                </div>

                <div data-id="element-102">
                  <label htmlFor="message" className="block text-cream text-sm font-medium tracking-wider uppercase mb-2" data-id="element-103">
                    Message
                  </label>
                  <textarea id="message" required rows={5} value={formData.message} onChange={e => setFormData({
                ...formData,
                message: e.target.value
              })} className="w-full bg-white/5 border border-white/10 text-cream px-4 py-3 focus:outline-none focus:border-amber/60 focus:ring-1 focus:ring-amber/30 transition-colors placeholder-gray-500 resize-none" placeholder="Tell us what's on your mind..." data-id="element-104" />
                </div>

                <div className="text-center sm:text-left pt-4" data-id="element-105">
                  <button type="submit" className="bg-amber text-charcoal px-10 py-4 font-semibold tracking-wide uppercase text-sm hover:bg-cream transition-colors shadow-lg inline-flex items-center space-x-3" data-id="element-106">
                    <span data-id="element-107">Send Message</span>
                    <Send size={16} data-id="element-108" />
                  </button>
                </div>
              </motion.form>}
          </div>
        </div>
      </div>
    </section>;
}